export default {
  All: 'Tất cả',
  ALL: 'TẤT CẢ',

  New: 'Mới',
  NEW: 'MỚI',

  Approved: 'Đã duyệt',
  APPROVED: 'ĐÃ DUYỆT',

  Reading: 'Đang đọc',
  READING: 'ĐANG ĐỌC',

  Submitted: 'Đã đọc',
  SUBMITTED: 'ĐÃ ĐỌC',

  Done: 'Đã duyệt',
  DONE: 'ĐÃ DUYỆT',

  Rejected: 'Bỏ qua',
  REJECTED: 'BỎ QUA',

  Cancelled: 'Đã hủy',
  CANCELED: 'ĐÃ HỦY',
  cancelled: 'đã hủy',
  CANCELLED: 'ĐÃ HỦY',

  Matched: 'Đã thực hiện',
  MATCHED: 'ĐÃ THỰC HIỆN',

  Unmatched: 'Chưa thực hiện',

  Completed: 'Đã thực hiện',
  COMPLETED: 'ĐÃ THỰC HIỆN',

  'Consultation Completed': 'Đã hoàn thành',
  'CONSULTATION COMPLETED': 'ĐÃ HOÀN THÀNH',

  'In Progress': 'Đang thực hiện',
  IN_PROGRESS: 'ĐANG THỰC HIỆN',

  Suspended: 'Tạm hoãn',
  SUSPENDED: 'TẠM DỪNG',

  Scheduled: 'Đã lên lịch',
  SCHEDULED: 'ĐÃ LÊN LỊCH',
  'Schedule Failed': 'Lỗi lên lịch',
  Scheduling: 'Đang lên lịch',
  Canceled: 'Đã hủy',
  'SCHEDULE FAILED': 'LỖI LÊN LỊCH',
  'IN PROGRESS': 'ĐANG THỰC HIỆN',
  'CONSULTATION IN PROGRESS': 'ĐANG DIỄN RA',
  'Consultation In Progress': 'ĐANG diễn ra',

  Active: 'Đang hoạt động',
  ACTIVE: 'ĐANG HOẠT ĐỘNG',

  Deactivated: 'Không hoạt động',
  DEACTIVATED: 'KHÔNG HOẠT ĐỘNG',

  Never: 'Không giới hạn',
  NEVER: 'KHÔNG GIỚI HẠN',

  Expired: 'Hết hạn',
  EXPIRED: 'Hết hạn',

  Abnormal: 'Bất thường',
  Normal: 'Bình thường',

  OPEN: 'MỞ',
  CLOSED: 'ĐÓNG',

  STAT: 'KHẨN CẤP',
  HIGH: 'CAO',
  ROUTINE: 'THƯỜNG',
  MEDIUM: 'TRUNG BÌNH',
  LOW: 'THẤP',
};
